const example = {
	attributes: {
		imageURL:
			"https://essential-addons.com/elementor/wp-content/uploads/2020/01/image_16.png",
	},
};
export default example;
